var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bto-base-widget",attrs:{"id":`widget-${_vm.widgetData.id}`}},[(_vm.depricated.indexOf(_vm.widgetData.compiledProps.is) < 0)?_c(_vm.widgetData.compiledProps.is,_vm._b({tag:"component"},'component',_vm.widgetData.compiledProps,false)):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }